import React, { useState } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Stack, Tab } from "@mui/material";

import Folders from "../../../Folders";
import CreateWheelPopup from "../../../CreateWheelPopup";

import { colors } from "../../../../utils";
import { TabsWrapper } from "../styles";
import WheelsTab from "./WheelsTab";

const ToolTabList = [
  { label: "Wheels", value: "0" },
  { label: "Folders", value: "1" },
];

const Tabs = () => {
  const [selectedTab, setSelectedTab] = useState("0");

  const handleTabChange = (e, newVal) => {
    setSelectedTab(newVal);
  };

  const renderTabChild = () => {
    return (
      <TabsWrapper sx={{ py: 1, width: "25vw" }}>
        <Box>
          <TabList
            variant="fullWidth"
            onChange={handleTabChange}
            sx={{
              height: "48px",
              zIndex: 1000,
              "& .MuiTabs-indicator": { display: "none !important" },
            }}
          >
            {ToolTabList.map(({ label, value }, index) => (
              <Tab
                key={value}
                label={label}
                value={value}
                style={{
                  marginRight: index == 0 && 10,
                  color:
                    selectedTab === value
                      ? colors.PrimaryPurple
                      : colors.NeutralText,
                  borderTop:
                    selectedTab === value
                      ? `2px solid ${colors.PrimaryPurple600}`
                      : "none",
                  backgroundColor:
                    selectedTab === value
                      ? colors.PrimaryPurple100
                      : colors.NeutralBackground,
                  fontWeight: "500",
                  textTransform: "capitalize",
                  fontSize: "16px",
                  lineHeight: "24px",
                  borderRadius: "4px",
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              />
            ))}
          </TabList>
        </Box>
      </TabsWrapper>
    );
  };

  return (
    <Stack
      className="wheels-tabs-wrapper"
      sx={{
        mt: 2,
        p: 2,
        backgroundColor: colors.white,
        borderRadius: 2,
        border: "1px solid #BBBBBB",
      }}
    >
      <TabContext value={selectedTab}>
        <TabPanel sx={{ px: 1, py: 0 }} value="0">
          <WheelsTab tabChild={renderTabChild}></WheelsTab>
        </TabPanel>
        <TabPanel sx={{ px: 1, py: 0 }} value="1">
          <Folders tabChild={renderTabChild} />
        </TabPanel>
      </TabContext>
      <CreateWheelPopup />
    </Stack>
  );
};

export default Tabs;
